import { isValidEmailAddress, fadeOutNotifications } from '../functions';
//import Swal from 'sweetalert2';

$(document).ready(function() {

	var isLoadingNewsletter = false;
    $(document).on('click', '#newsletter-btn', function() {

        if (isLoadingNewsletter) {
            console.log('is loading...');
            return false;
        }

		$('#newsletter-email').removeClass('is-invalid');
		if ($('#newsletter-email').val() == '') {
			$('#newsletter-email').addClass('is-invalid');
			return false;
		}

		$('#newsletter-terms-and-condition').removeClass('is-invalid');
		if (!$('#newsletter-terms-and-condition').is(':checked')) {
			$('#newsletter-terms-and-condition').addClass('is-invalid');
			return false;
		}

		isLoadingNewsletter = true;

		var values='';
		values+='email=' + $('#newsletter-email').val();
		values+='&_token=' + $('#newsletter-token').val();

		$.ajax({
			type: "POST",
			url: baseURL + "/newsletter/save",
			dataType: "JSON",
			data: values,
			success: function(response) {
				isLoadingNewsletter = false;

				if (response.status == 0) {
					var errorHtml = '';
					for(var errorKey in response.errors) {
						if(!response.errors.hasOwnProperty(errorKey)) continue;
						for(var error in response.errors[errorKey]) {
							if (errorHtml != '') {
								errorHtml += '<br />';
							}
							errorHtml += `${response.errors[errorKey][error]}`;
						}
					}
					Swal.fire({
						// icon: 'error',
						title: 'Oops...',
						text: errorHtml
					});
					return false;
				}

				if (response.status == 1) {

					Swal.fire({
						// icon: 'success',
						title: 'Success...',
						text: response.message
					});

					$('#newsletter-email').val('');
					$('#newsletter-terms-and-condition').attr('checked', false)

					return false;
				}

				Swal.fire({
					// icon: 'error',
					title: 'Oops...',
					text: response.message
				});
				return false;
			},
			error(error) {
                isLoadingNewsletter = false;
            }
		});

		return false;

    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/newsletter.js